import {
	SportStatisticsHub as GPSportStatisticsHub,
	SportStatisticsHubOptions,
	IConnection,
} from "@gp/hub";

export class SportStatisticsHub extends GPSportStatisticsHub {
	constructor(connection: IConnection) {
		super(new SportStatisticsHubOptions(), connection);

		this.initialize();
	}
}
